(function ($, njm) {
    'use strict';

    njm.views.messageCenter = Backbone.View.extend({

        events: {
            "click .message-article .item": "setActive"
        },

        initialize: function () {
            window.messageCenterError = this.errorMsg;
            window.fnMessageCenterPost = this.fnMessageCenterPost;
            window.fnMessageArticlePost = this.fnMessageArticlePost;
            window.fnPagination = this.fnPagination;
        },

        setActive: function (event) {
            $('.comp-message-center .message-article').removeClass('active');
            $(event.target).closest('.message-article').addClass('active');
        },

        errorMsg: function () {
            var errorText = $('.comp-message-center #error-text').val(),
                errorEl = $('<span />');
            errorEl.addClass('no-content').text(errorText);
            $('.comp-message-center #right-panel').html(errorEl);
        },

        fnMessageCenterPost: function (event) {
            if (event !== undefined) {
                var pageIndex = $(event.target).data("page-index");
                var isArchived = $(event.target).data("isarchived");
                if (pageIndex !== undefined && isArchived !== undefined) {
                    $.ajax({
                        url: "/sitecore/api/comm/MessageCenter/MessageListingPaginationPost",
                        type: "POST",
                        data: {
                            userCategory: $("#userCategory").val(),
                            isArchive: isArchived,
                            pageIndex: pageIndex,
                            pageSize: $("#pageSize").val(),
                            searchText: $("#searchText").val()
                        },
                        context: this,
                        success: function (data) {
                            $("#resultContainer").empty();
                            $("#resultContainer").html(data);
                        },
                        failure: function (data) {
                            // Take to error page
                            var errorText = $('.comp-message-center #error-text').val(),
                                errorEl = $('<span />');
                            errorEl.addClass('no-content').text(errorText);
                            $('.comp-message-center #right-panel').html(errorEl);
                            //     alert(data);
                        }
                    });
                }
                else {
                    var errorText = $('.comp-message-center #error-text').val(),
                        errorEl = $('<span />');
                    errorEl.addClass('no-content').text(errorText);
                    $('.comp-message-center #right-panel').html(errorEl);
                }
            }
            else {
                var errorText = $('.comp-message-center #error-text').val(),
                    errorEl = $('<span />');
                errorEl.addClass('no-content').text(errorText);
                $('.comp-message-center #right-panel').html(errorEl);
            }
        },
        fnMessageArticlePost: function (event) {
            if (event !== undefined) {
                var messageId = $(event.target).closest('.item').data("message-id");
                if (messageId !== undefined) {
                    $.ajax({
                        url: "/sitecore/api/comm/MessageCenter/MessageItemDetails",
                        type: "POST",
                        data: {
                            messageId: messageId
                        },
                        context: this,
                        success: function (data) {
                            $('.comp-message-center #right-panel').empty();
                            $('.comp-message-center #right-panel').html(data);
                        },
                        failure: function (data) {
                            var errorText = $('.comp-message-center #error-text').val(),
                                errorEl = $('<span />');
                            errorEl.addClass('no-content').text(errorText);
                            $('.comp-message-center #right-panel').html(errorEl);
                        }
                    });
                }
                else {
                    var errorText = $('.comp-message-center #error-text').val(),
                        errorEl = $('<span />');
                    errorEl.addClass('no-content').text(errorText);
                    $('.comp-message-center #right-panel').html(errorEl);
                }
            }
            else
            {
                var errorText = $('.comp-message-center #error-text').val(),
                errorEl = $('<span />');
                errorEl.addClass('no-content').text(errorText);
                $('.comp-message-center #right-panel').html(errorEl);
            }
        },

        fnPagination: function (event,mode) {
            if (event !== undefined) {
                if (event.keyCode === 13) {
                    //If Page Input is less than 1 then default to 1. If page input greater than the total page count then default to totalpage count.  
                    var pageInput = $('.pageInput').val();
                    var totalPageCount = $("#TotalPageCount").val();
                    var isArchived = $("#hid-isArchived").val();
                    if (pageInput !== undefined && totalPageCount !== undefined && isArchived !== undefined) {                       
                        if (pageInput.length == 0 || parseInt(pageInput) < 1) {
                            pageInput = 1
                        }
                        else if (parseInt(totalPageCount) < parseInt(pageInput)) {
                            pageInput = totalPageCount
                        }
                        if (!mode) {
                            $(".inputPage").attr('href', $(".inputPage").attr('href').replace("pageInput", pageInput));
                            document.getElementById('inputPage').click();
                        }
                        else {
                            
                            $('#pageIndexInput').data('page-index', pageInput);
                            $('#pageIndexInput').data('isarchived', isArchived);
                            $("#pageIndexInput").click();
                        }
                        
                    }
                }
            }
            else {
                var errorText = $('.comp-message-center #error-text').val(),
                errorEl = $('<span />');
                errorEl.addClass('no-content').text(errorText);
                $('.comp-message-center #right-panel').html(errorEl);
            }
        }
    });
})(jQuery, njm);
